import { render, staticRenderFns } from "./AdminQuietanziantiView.vue?vue&type=template&id=dda7676e&"
import script from "./AdminQuietanziantiView.vue?vue&type=script&lang=ts&"
export * from "./AdminQuietanziantiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports